import {
  GET_OUT_RIGHT_WON_COUPONS_REQUEST,
  GET_OUT_RIGHT_WON_COUPONS_SUCCESS,
  GET_OUT_RIGHT_WON_COUPONS_FAILURE,
  RESET_OUT_RIGHT_WON_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    isLoadMoreButtonVisible: false
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OUT_RIGHT_WON_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_OUT_RIGHT_WON_COUPONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_OUT_RIGHT_WON_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_OUT_RIGHT_WON_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };
    default:
      return state;
  }
};
